<template>
  <div class="card">
    <h3 class="card-title">LISTAR DIAGNÓSTICOS</h3>
    <div v-if="diagnosticos">
      <table-list
        ref="tablelist"
        :showFilter="true"
        :data="diagnosticos"
        :header="headers"
        :body="body"
        :actionButton="actionButton"
        @rowClicked="showDiagnostico"
      ></table-list>
    </div>
    <modal v-if="openNew" @close="openNew = false">
      <nuevo-diagnostico slot="modal-body" @saved="refresh"></nuevo-diagnostico>
    </modal>
  </div>
</template>
<script>
import { DiagnosticosServices } from "../services/DiagnosticosServices";
import TableList from "@/components/elements/TableList";
import Modal from "@/components/elements/Modal";
import NuevoDiagnostico from "./NuevoDiagnostico.vue";
export default {
  components: { TableList, Modal, NuevoDiagnostico },
  name: "ListarDiagnosticos",
  data() {
    return {
      diagnosticos: null,
      headers: DiagnosticosServices.headers(),
      body: DiagnosticosServices.body(),
      actionButton: {
        text: "Nuevo diagnóstico",
        action: () => {
          this.openNew = true;
        },
      },
      openNew: false,
    };
  },
  mounted() {
    DiagnosticosServices.api.getAll().then((diagnosticos) => (this.diagnosticos = diagnosticos));
  },
  methods: {
    refresh() {
      this.openNew = false;
      DiagnosticosServices.api.getAll().then((diagnosticos) => {
        this.diagnosticos = diagnosticos;
        this.$refs["tablelist"].refresh(diagnosticos);
      });
    },
    showDiagnostico(diagnostico) {
      this.$router.push({ name: "VerDiagnostico", params: { id: diagnostico.id } });
    },
  },
};
</script>
